import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

export interface IBannerPageDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  handleDelete: () => void
  leastDestructiveRef: any
}

export function BannerPageDeleteModal({
  isOpen,
  onClose,
  handleDelete,
  leastDestructiveRef
}: IBannerPageDeleteDialogProps) {
  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Remover Banner
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja fazer isso?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3}>
              Sim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
